import DownloadService from './services';
import DownloadTypes from './types';

export const downloadFile = (hash: string) => DownloadTypes.downloadFile.createAction(() => DownloadService.downloadFile(hash));

export const validateDownloadHash = (hash: string) =>
  DownloadTypes.validateDownloadHash.createAction(() => DownloadService.validateDownloadHash(hash));
